import { render, staticRenderFns } from "./ReactionTestsTabNewQuestionModel.vue?vue&type=template&id=2328e482&"
import script from "./ReactionTestsTabNewQuestionModel.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsTabNewQuestionModel.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsTabNewQuestionModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsTabNewQuestionModel.vue"
export default component.exports